module.exports = __webpack_public_path__ + "static/media/total-consultation-mob.920f95d1.svg";